<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />

          <action-button v-show="buttonStatus == 0" @click="exportCsv" icon="exportdata" bold :text="lang.button_ExportCsv" :tooltip="lang.button_ExportCsv" :disabled="exportCsvButtonStatus" />
          <action-button v-show="buttonStatus == 0" @click="exportFiles" icon="exportdata" bold :text="lang.button_ExportFiles" :tooltip="lang.button_ExportFiles" :disabled="exportFilesButtonStatus" />

          <action-button v-show="buttonStatus == 0" @click="importing" icon="import" bold :text="lang.button_Import" :tooltip="lang.button_Import" :disabled="importButtonStatus" />
          <action-button v-show="buttonStatus == 0" @click="approving" icon="import" bold :text="lang.button_Approve" :tooltip="lang.button_Approve" :disabled="approveButtonStatus" />


        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/LibraryManager/Views/LibraryImport/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      importButtonStatus: true,
      exportCsvButtonStatus: false,
      exportFilesButtonStatus: false,
      approveButtonStatus: true,
      backButtonStatus: false,
      imported: false,
      buttonStatus: 0,
      delimiter: ",",
      types: []
    }
  },
  computed:{
    lengthMapped(){

      if (this.$store.getters.importLibraryArray.length > 0){
        this.importButtonStatus = false;

      }else{
        this.importButtonStatus = true;

      }
      return this.$store.getters.importLibraryArray.length;
    }

  },
  created() {

    this.importButtonStatus = true;
  },
  watch: {
    lengthMapped: function(newVal){

      if (newVal > 0){
        this.importButtonStatus = false;

      }else{
        this.importButtonStatus = true;

      }

    },


  },
  methods: {

    switchButtons(index){
      this.buttonStatus = index;
    },
    exportCsv() {
      console.log("exportCsv")
      this.$store.dispatch("showLoader", { visible: true, text: "download" });
      let vue = this;

      let obj = {
        categoryId: this.$store.getters.selectedTreeLibraryItemObject.categoryId

      };

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibrariesCSVFile", obj)
      .then(result => {
        //console.log(result);
        let fileName = "Libraries.csv";

        const blob = new Blob([result.data], {type: "text/csv"});

        let a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = fileName;

        document.body.appendChild(a);

        a.click();
        document.body.removeChild(a);
        vue.$store.dispatch("showLoader", { visible: false });
      })
      .then(function() {
        vue.$store.dispatch("showLoader", { visible: false });
      });

    },
    exportFiles() {
      console.log("exportFiles")
      this.$store.dispatch("showLoader", { visible: true, text: "download" });
      let vue = this;

      let obj = {
        categoryId: this.$store.getters.selectedTreeLibraryItemObject.categoryId

      };

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getLibrariesFilesForUpdate", obj)
      .then(result => {
        console.log(result);
        let fileName = "Libraries.zip";

        //const blob = new Blob([result.data], {type: "text/csv"});

        let a = document.createElement("a");
        a.href = URL.createObjectURL(result.data);
        a.download = fileName;

        document.body.appendChild(a);

        a.click();
        document.body.removeChild(a);
        vue.$store.dispatch("showLoader", { visible: false });
      })
      .then(function() {
        vue.$store.dispatch("showLoader", { visible: false });
      });


    },
    importing(){
console.log("importing")

      let _vue = this;


      this.$store.dispatch("showLoader", {visible: true, text: "load"});

      const arr = this.$store.getters.importLibraryArray;

      this.$store.dispatch(this.$store.getters.sectionPrefix+"_importLibrariesBulk", arr)
        .then(function(result){

          console.log(result.data)




          if (result.status == "OK"){

            _vue.imported = true;

            if (result.data.length == 0){

              let obj = {
                text: _vue.lang.alert_success_importLibrariesBulk,
                time: 5,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

              // _vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_resetMapField");

              // const reloadObj = {
              //     status: true,
              //     name: "ImportHistoryComponent"
              // }
              //_vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            }else {

              const arr = result.data;

              //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix +"_setNotImportedParts", arr);


              let obj = {
                text: _vue.lang.alert_error_importLibrariesBulk + result.message,
                time: 15,
                type: "warning"
              }

              _vue.$store.dispatch("displayFooterAlert", obj)

            }





          }else{

            let obj = {
              text: _vue.lang.alert_error_importLibrariesBulk + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj)


          }



      })
      .then(function() {

        _vue.$store.dispatch("showLoader", {visible: false});

      })



    },
    approving() {
      console.log("approve")
    },



    back(){


      if (this.imported){
        const reloadObj = {
            status: true,
            name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);


      }

      let to = this.$route.query.from;




      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },
    toggleRightPanel(){

      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;

    },
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;

    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryImport/Middle/Middle.vue